import React from "react";
import { LuCrown, LuHouse, LuRefreshCcw } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

export default function CheckersResult({ isCompleted, winner, myPiece, onPlayAgain }) {
  const navigate = useNavigate();
  if (!isCompleted) return null;

  const text = winner === myPiece ? "You win" : winner ? "You lose" : "Draw";
  const tone =
    winner === myPiece
      ? "border-brand-emerald/25 bg-brand-emerald/10 text-brand-emerald"
      : winner
        ? "border-brand-rose/25 bg-brand-rose/10 text-brand-rose"
        : "border-brand-cyan/25 bg-brand-cyan/10 text-brand-cyan";

  return (
    <div className="flex w-full max-w-md items-center justify-between gap-3 rounded-2xl border border-black/60 bg-[linear-gradient(145deg,#0b1117,#030607)] px-3 py-2.5 shadow-[0_18px_50px_rgba(0,0,0,0.48),inset_0_1px_0_rgba(255,255,255,0.055)]">
      <div className="flex min-w-0 items-center gap-2">
        <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-xl border ${tone}`}>
          <LuCrown size={16} />
        </span>
        <div className="min-w-0">
          <div className="truncate font-display text-base font-semibold tracking-tight text-text-primary">{text}</div>
          <div className="text-[10px] uppercase tracking-[0.16em] text-text-faint">Game complete</div>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {onPlayAgain ? (
          <button
            type="button"
            onClick={onPlayAgain}
            className="h-9 w-9 grid place-items-center rounded-xl border border-[#C6A15B]/35 bg-[#C6A15B]/12 text-[#FBBF24] transition hover:bg-[#C6A15B]/18"
            aria-label="Play again"
            title="Play again"
          >
            <LuRefreshCcw size={16} />
          </button>
        ) : null}
        <button
          type="button"
          onClick={() => navigate("/")}
          className="h-9 w-9 grid place-items-center rounded-xl border border-border-soft bg-background-app-panel text-text-secondary transition hover:bg-surface-elevated hover:text-text-primary"
          aria-label="Home"
          title="Home"
        >
          <LuHouse size={16} />
        </button>
      </div>
    </div>
  );
}
